import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function CTASection() {
  const handlePurchase = () => {
    // Track AddToCart event before redirecting
    trackAddToCart();
    // Small delay to ensure tracking fires before redirect
    setTimeout(() => {
      window.location.href = 'https://pay.hotmart.com/U104232902M';
    }, 300);
  };
  return <Section background="navy" className="py-24 text-center relative overflow-hidden" data-id="element-27">
      {/* Background Glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,#334155_0%,#0f172a_100%)] pointer-events-none" data-id="element-28" />

      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-29">
        {/* Confrontative Truth */}
        <div className="mb-16" data-id="element-30">
          <h2 className="text-3xl md:text-5xl font-serif text-white mb-8 leading-tight" data-id="element-31">
            No necesitas más fuerza de voluntad. <br data-id="element-32" />
            <span className="text-amber-400" data-id="element-33">Necesitas una señal.</span>
          </h2>
          <p className="text-xl text-slate-300 mb-8" data-id="element-34">
            Y cuando esa señal se repite, noche tras noche… tu cuerpo deja de
            pelear. Porque ya sabe qué viene.
          </p>
        </div>

        {/* Final Card */}
        <motion.div whileHover={{
        y: -5
      }} className="bg-white text-navy-900 p-8 md:p-12 rounded-3xl shadow-2xl max-w-2xl mx-auto" data-id="element-35">
          <p className="text-slate-600 mb-6 font-medium uppercase tracking-wide text-sm" data-id="element-36">
            Disponible Ahora
          </p>
          <h3 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-37">
            Dormir Sin Pensar
          </h3>
          <p className="text-lg text-slate-600 mb-8" data-id="element-38">
            Protocolo 14 Noches para Apagar la Mente (40+)
          </p>

          <Button size="lg" fullWidth className="text-lg py-5 shadow-xl shadow-amber-500/20 mb-4" onClick={handlePurchase} data-id="element-39">
            Consigue el Protocolo por $7,99
          </Button>

          <p className="text-sm text-slate-500" data-id="element-40">
            Empieza esta noche con la versión mínima (3 minutos).
          </p>
        </motion.div>
      </div>
    </Section>;
}